import { memo, useEffect, useRef, useState } from "react"
import redirectURL from "../redirectURL";
import Loader from "./Loader";
import { keys } from "highcharts";
import { all } from "axios";

const BulkForceClose = (props) => {

    const [slider, setSlider] = useState('')
    const [overlay, setOverlay] = useState('show-n')
    const [loader, setLoader] = useState('show-n')
    const [pageLoader, setPageLoader] = useState(false)
    const [file, setFile] = useState('')
    const [primaryReasons , setPrimaryReasons] = useState([]);
    const [allReasons , setAllReasons] = useState([])
    const fileRef = useRef(null)

    const bulkUploadClick = () => {
        setSlider('slider-translate-40p')
        setOverlay('show-m')
    }

    const submitEventHandler = async (e) => {
        e.preventDefault()
        setLoader('show-m')
        let formData = new FormData()
        formData.append('uploadFile', file)
        formData.append('email', props?.user?.email)
        await redirectURL.post("/uploadBulkForceClose", formData, {
            headers: {
                'content-type': 'multipart/form-data'
            }
        })
            .then(response => {
                if (response.data.status == "success") {
                    props.setShow(true)
                    props.setTitle(response.data.message)
                    props.setType("success")
                    props.loadConsignmentsData(setPageLoader)
                    setLoader("show-n")
                    setSlider('')
                    setOverlay("show-n")
                    setFile('')
                    fileRef.current.value = ''
                }
                else {
                    props.setShow(true)
                    props.setTitle(response.data.message)
                    props.setType("danger")
                    setLoader("show-n")
                    setOverlay("show-n")
                }
            })
            .catch(err => console.log(err))
    }

    const closeSlider = () => {
        setSlider('')
        setFile('')
        setOverlay('show-n')
        fileRef.current.value = ''
    }
    const resetUpload = () => {
        setFile('')
        fileRef.current.value = ''
    }
    useEffect(() => {
        if (!props.data) return;
        const primaryReasons = [];
        const allReasons = [];
        props.data.forEach(obj => {
            Object.entries(obj).forEach(([key, value]) => {
                if (Array.isArray(value)) {
                    primaryReasons.push(key);    // just the key string
                    allReasons.push(value);      // the array of values
                }
            });
        });
        setPrimaryReasons(primaryReasons); // array of keys
        setAllReasons(allReasons);         // array of arrays
    }, [props.data]);

    return (
        <>
        <Loader show={pageLoader} />
            <div className={"slide-r " + slider} style={{ overflow: "hidde" }}>
                <div className="slide-r-title">
                    <h4>
                        Bulk Force Close
                        <span className="float-right closebtn" style={{ marginRight: "25px" }} onClick={closeSlider} >X</span>
                    </h4>
                </div>
                <div className="slide-r-body" style={{ position: "relative" }}>
                    <div className={"dataLoad " + (loader)} style={{ opacity: "0.5" }}>
                        <div style={{ position: "fixed", left: "50%", top: '50%' }}>
                            <div class="loader-box">
                                <div class="loader-box">
                                    <div class="rotate dashed colored"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="container-fluid">
                        <form id="upform" className="theme-form" onSubmit={submitEventHandler}>
                            <div className="form-group mt-20p">
                                <label className="">Upload File</label>
                                <input type="file" ref={fileRef} name="uploadFile" onChange={e => setFile(e.target.files[0])} className="form-control" required />
                            </div>
                            <div className="form-group">
                                <button type="submit" className="btn btn-success">Submit</button>
                                <button type="button" onClick={resetUpload} className="btn btn-default">Cancel</button>
                            </div>
                        </form>
                        <div className="form-group">
                            <p style={{ color: "#ff0000" }}>*Note: All fields are mandatory</p>
                            <p><b>FO numbers:</b> List of FO numbers</p>
                            <p><b>Customer Codes:</b> List of Customer Codes</p>
                            <p><b>Reason:</b> List of Reason</p>
                        </div>
                        <div className="form-group">
                            <a className="btn btn-primary" href={require('../../assets/files/ForceCloseBulk.csv')} target="_blank">Sample Template</a>
                        </div>
                        <div className="form-group">
                            <div><table className="table-force-closure">
                                <thead className="header_force_closure">
                                    <tr>
                                        <td className="force_closure_headers">Primary Reasons</td>
                                        <td>Force Closure Reasons</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {primaryReasons.map((title, sectionIndex) =>
                                        allReasons[sectionIndex].map((item, itemIndex) => (
                                            <tr key={`${title}-${itemIndex}`}>
                                                {itemIndex === 0 && (
                                                    <td rowSpan={allReasons[sectionIndex].length} className ="force_close_def">
                                                        {title}
                                                    </td>
                                                )}
                                                <td className ='table_def'>{item}</td>
                                            </tr>
                                        ))
                                    )}
                                </tbody>


                            </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"overlay-part " + (overlay)} style={{ zIndex: "10" }}onClick={closeSlider}></div>
            <button type="button" title="Bulk Force Close FO Deliveries" className="btn btn-warning float-right action_btn main-page-button" style={{ marginLeft: "10px" }} onClick={bulkUploadClick}>Bulk Force Close</button>
        </>
    )
}
export default memo(BulkForceClose)